import React from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

interface AuthGuardProps {
  children: React.ReactNode;
}

export default function AuthGuard({ children }: AuthGuardProps) {
  const { session, user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-light-gray via-white to-light-gray-alt dark:from-soft-black dark:via-deep-purple/20 dark:to-soft-black font-exo flex items-center justify-center">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="text-center"
        >
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-darling-lilac/10 dark:bg-darling-lilac/20 mb-4">
            <Loader2 className="h-8 w-8 text-darling-lilac animate-spin" />
          </div>
          <p className="text-soft-black/70 dark:text-light-gray/80 font-exo">
            Carregando...
          </p>
        </motion.div>
      </div>
    );
  }

  if (!session) {
    navigate('/login', { replace: true });
    return null;
  }

  // Redirecionar para definir senha se necessário
  if (user?.must_set_password && location.pathname !== '/set-password') {
    return <Navigate to="/set-password" replace />;
  }

  return <>{children}</>;
}